import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type SubscriptionLicenceState = CommonTableState;

/** Sekce Licence na admin dashboardu předplatných. Bez filtru období - ten patří do sekce Faktury. */
const initialState: SubscriptionLicenceState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "company.id", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnOrder: [
            "company.id",
            "category",
            "responsiblePerson.id",
            "responsiblePerson.email",
            "responsiblePerson.phone",
            // Schovaný, ale zůstává v pořadí i v definici — filtruje na něj dlaždice „Aktivní".
            "licenceStatus",
            "amount",
            "categoryDate",
            "company.vatNumber",
            "tariff.id",
            "subscriptionPaymentMethod",
            "dueDate",
            "graceDueDate",
            "subscriptionVariableSymbol",
            "terminationIssuedDate",
            "terminationFromDate",
            "terminationToDate",
            "terminationReason",
            "trialEndDate",
            "activationDate",
            "mrt-row-actions",
        ],
        columnVisibility: {
            // Management chce vidět jen Společnost, Kategorii, Odpovědnou osobu a její kontakt.
            // „Stav licence" se schovává, ale NEodstraňuje — dlaždice „Aktivní" na něj zapisuje filtr
            // a JmfTable ho odešle i u neviditelného sloupce (columnFilters a columnVisibility jsou
            // nezávislé stavy). Uživatel si ho může kdykoli zapnout přes výběr sloupců.
            licenceStatus: false,
            amount: false,
            categoryDate: false,
            "company.vatNumber": false,
            "tariff.id": false,
            subscriptionPaymentMethod: false,
            dueDate: false,
            graceDueDate: false,
            subscriptionVariableSymbol: false,
            terminationIssuedDate: false,
            terminationFromDate: false,
            terminationToDate: false,
            terminationReason: false,
            trialEndDate: false,
            activationDate: false,
        },
        density: "compact",
    },
};

export const subscriptionLicenceSlice = createSlice({
    name: "subscriptionLicence",
    initialState: initialState,
    reducers: {
        updateSubscriptionLicenceTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

export const { updateSubscriptionLicenceTableState } = subscriptionLicenceSlice.actions;

export default subscriptionLicenceSlice.reducer;
